import { combineReducers } from 'redux';
import authReducer from './main/authReducer'
import teacherOnboardReducer from './teacherOnboard/teacherOnboardReducer'
import courseReducer from './course/courseReducer';

const rootReducer = combineReducers({
	auth: authReducer,
	teacherOnboardReducer,
	courseReducer
});

export default rootReducer;
